import React, { useMemo } from 'react';
import { IVessel } from '../../../../../util/varibles/interface';
import styles from '../style.module.scss';

interface IProps {
    source: any[]
    vessels: IVessel[]
}

const AvailableTimes: React.FC<IProps> = ({ source, vessels }) => {
    const vesselIds = useMemo(() => new Set(vessels.map(item => item.id)), [vessels]);
    return <>
        {source.map((data: any) => {
            const { start_time, finish_time, isPermission, vesselId } = data;

            if (!vesselIds.has(vesselId))
                return null;

            const style = {
                '--el-left': start_time,
                '--el-width': finish_time - start_time,
                top: `calc(var(--${vesselId}-top) + var(--more-height)`,
                height: `calc(var(--${vesselId}) + var(--more-height, 0px))`
            } as any

            return <div
                key={data.id}
                className={styles.availableTime}
                style={style}
                data-is-permission={isPermission}
            />;
        })}
    </>;
};

export default AvailableTimes;
